import styled from 'styled-components';

import { colorInterfaceDarkUp } from '@useblu/ocean-tokens/web/tokens';

import { InformationCircle } from '@useblu/ocean-icons-react';

export const CustomIcon = styled(InformationCircle)`
  color: ${colorInterfaceDarkUp};
  height: 16px;
  width: 16px;
  cursor: pointer;
`;
